import { createTheme } from '@mui/material/styles';
import { blue, red, grey, orange } from '@mui/material/colors';

const theme = createTheme({
	palette: {
		common: {
			black: grey[700],
			white: grey[50],
		},
		primary: {
			main: blue[700],
			dark: blue[900],
			light: blue[50],
			contrastText: blue[700],
		},
		secondary: {
			main: red[700],
			dark: red[900],
			contrastText: red[700],
		},
		warning: {
			main: orange[700],
			dark: orange[900],
			contrastText: orange[700],
		},
		error: {
			main: red[700],
			dark: red[900],
			contrastText: red[700],
		},
		background: {
			default: grey[50],
		},
	},
	typography: {
		fontFamily: 'Meiryo UI',
		button: {
			textTransform: 'none',
		},
		h1: {
			fontSize: '1.7rem',
		},
		h2: {
			fontSize: '1.2rem',
		},
		h3: {
			fontSize: '1.1rem',
		},
	},
	zIndex: {
		appBar: 1100,
		drawer: 1200,
		backdrop: 2000, // カスタム定義
		dialog: 2100, // カスタム定義
	},
});

export default theme;
